import { Box } from '@mui/material';
import React from 'react';

export interface ColumnProps {
  children: React.ReactNode;
  lastColumn: boolean;
  isSmallDevice: boolean;
}

export const Column = ({ children, lastColumn, isSmallDevice }: ColumnProps) => (
  <Box height="100%" paddingRight={lastColumn ? '0px' : '8px'} overflow={isSmallDevice ? 'auto' : 'hidden'}>
    {children}
  </Box>
);
